import React, { Component } from 'react';
import PerfectScrollbar from 'perfect-scrollbar';
import $ from "jquery";

class StepThree extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ps: null,
            time: {
                time:this.props.data.time,
                stylist: this.props.data.stylist
            },
        }
    }

    componentDidMount = () => {
        this.height();
        const ps = new PerfectScrollbar('.stepThree', {
            wheelSpeed: 2,
            wheelPropagation: true,
            minScrollbarLength: 20
        });
        this.setState((prevState) => {
            prevState.ps = ps;
            return prevState;
        })
        $(window).off();
        $(window).on("resize", this.resize.bind(this));
    }

    componentDidUpdate = () => {
        this.height();
        this.state.ps.update();
    }

    height = () => {    
        let totalHeight = $(window).outerHeight();
        totalHeight = (totalHeight > 900) ? 900 : totalHeight;
        let heightHeader = $(".header").outerHeight();
        let heightSteps = $(".steps").outerHeight();
        let heightPagination = $(".pagination-btns").outerHeight();

        let occupied = 
          heightHeader //header
        + heightSteps //steps
        + heightPagination //pagination
        - 5;
        
        let available = totalHeight - occupied + "px";
        document.querySelector(".stepThree").style.height = available;     
    }

    resize = () => {
        this.height();
        this.state.ps.update();
    }

    uniqueid = () => {
        return Math.random().toString(36).replace(/[^a-z]+/g, '');
    }

    isTimeSelected = (time, stylist) => {
        let result = false;
        if (this.state.time)
            result = (time["time"] === this.state.time["time"]) && (stylist["id"] === this.state.time["stylist"]["id"]);
        return result;
    }

    getTimeButtonClass = (time, stylist) => {
        let cls;
        if (time["active"] && this.isTimeSelected(time, stylist)) {
            cls = "times-unit button is-danger";
        } else if (time["active"] && !this.isTimeSelected(time, stylist)) {
            cls = "times-unit button";
        } else {
            cls = "times-unit button has-background-grey-lighter";
        }
        return cls;
    }

    onClickTimeButton = (time, stylist) => {
        this.setState((prevState) => {
            let newTime = {
                stylist: stylist,
                time: time["time"],
            }
            prevState.time = newTime;
            return prevState;
        }, () => {
            this.props.setTime(this.state.time["time"]);
            this.props.setStylist(this.state.time["stylist"]);
        });
    }

    renderContent() {
        
        if (this.props.times && (this.props.times.length === 0)) {
            this.openModal("no-times");
        } else {
            if (this.props.times) {
                let blocks = [];
                this.props.times.forEach((stylist, index) => {
                    let times = [];
                    let key = this.uniqueid();
                    stylist["times"].forEach((time, index) => {
                        let id = this.uniqueid();
                        let key = this.uniqueid()
                        let cls = this.getTimeButtonClass(time, stylist);
                        let el = (time["active"]) ?
                            <button id={id} key={key} className={cls} onClick={() => this.onClickTimeButton(time, stylist)}>{time["time"]}</button> :
                            <button key={key} className={cls} disabled>{time["time"]}</button>
                        times.push(el);
                    });
                    blocks.push(
                        <div className="card times" key={key}>
                            <div className="card-image times-image">
                                <figure className="image is-128x128">
                                <img src={"data:image/png;base64, " + this.props.images["id_" + stylist["id"]]} />
                                </figure>
                            </div>
                            <div className="card-content times-content">
                                <div className="times-content-name">{stylist["naam"]}</div>
                                <div className="times-content-body">{times}</div>
                            </div>
                        </div>
                    );
                });
                return blocks;
            } else {
                return <div className="loader-container"><div className="loader"></div></div>
            }
        }
    }

    color(e) {
        let id = e.target.id;
        $("#" + id).toggleClass("is-danger");
    }

    openModal = (name) => {
        $("." + name).addClass("is-active");
    }

    closeModal = (name) => {
            $("." + name).removeClass("is-active");
    }

    maxModal = () => {
    let cHeight = $(".container").height();
        return  (cHeight - 154) + "px";
    }

    render() {
        return (
            <React.Fragment>
                <div className="columns" style={{width: "100%"}}>
                    <div className="column">
                        <div className="stepThree">
                            {this.renderContent()}
                        </div>
                    </div>
                </div>
                <div className="modal no-times">
                    <div className="modal-background"></div>
                    <div className="modal-content">
                        <div className="cModal" style={{maxHeight: this.maxHeightModalContent}}>
                            <div className="cModal-header">
                                Melding
                            </div>
                            <div className="cModal-content stylists-content" style={{maxHeight: this.maxModal()}}>
                            <p>
                                Er zijn geen tijden beschikbaar voor de gekozen datum
                            </p>
                            </div>
                            <div className="cModal-footer">
                                <button className="button is-danger is-pulled-right" onClick={(e) => this.closeModal("no-times")}>Sluiten</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default StepThree;